import { defineMessages } from 'react-intl';

type MessageKeys = 'loadingMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		loadingMessage: {
			id: 'paginated-picker.async-select.menu-list.loading-message.loading-message',
			defaultMessage: 'Loading...',
			description: 'The text for when options are being loaded in dropdown',
		},
	});

export default message;
